import axios from 'axios';

export const unLockVersion = async (versionId: string | undefined) =>
    axios
        .post(`configurator/unlock-version/${versionId}`)
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
